import React, { useState } from 'react'
import NetInfo from '@react-native-community/netinfo'
import { schedulesServices } from '../../../../database/schedules.database'
import { FORM_SCHEDULE_STATUS, FORM_TYPES } from '../constants/constants.stores'
import { uploadImage } from '../../imageUploader/ImageStorage'
import { useNavigation } from '@react-navigation/native'
import { useFormContext, useFormRefrigeratorContext } from '../context/form.context'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_save_form } from '../../../services/schedule.services'
import { FinishSheet } from '../ExecutionView'
import { useStoreContext } from '../context/store.context'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { captureAndSaveDataError, isValidDateString, isValidMongoId, retryDbOperation, validateConnectionNetwork } from '../../../utils/functions.utils'
import { generateDayUniqueId } from '../../../utils/basicUtils'
import { useStoreKpisStore } from '../../../redux/zustand/storeKpisStore'
import { useFormSendStatusStore } from '../../../redux/zustand/formSendStatusStore'

interface useFormViewI {
    store_id?: string
    form_id?: string
    schedule_id?: string
    checkin_id?: string
    reloadFormsData?: () => void
    hasFinishSheet?: boolean
    clearRegisterDatabaseLocal?: (type?: string | null) => void
    title?: string
}

export const useFormView = ({
    form_id = null,
    schedule_id = null,
    store_id = null,
    checkin_id,
    reloadFormsData,
    hasFinishSheet,
    clearRegisterDatabaseLocal,
    title,
}: useFormViewI) => {
    // console.log('🚀 ~desde fov schedule_id:', schedule_id, checkin_id, store_id)
    const defaultScheduleId = schedule_id
    const defaultFormId = form_id
    const defaultStoreId = store_id
    const _INCIDENCE = true

    const navigation = useNavigation()
    const { formsContext, setFormsContext, setReloadChange, updateProgressForm, updateStatusForm, currentCheckin } = useFormContext()
    const { getFormRefrigerator, updateActveFormRefrigerator, form_refrigerators_main, forms_refrigerators } = useFormRefrigeratorContext()
    const { openBottomSheet, closeBottomSheet, isOpen } = useBottomSheet()
    const { setReloadFormsFn, reloadForms } = useStoreContext()

    const [isLoadingReload, setIsLoadingReload] = useState(false)
    const [buttonActive, setbuttonActive] = useState(true)
    const [reloadData, setReloadData] = useState(true)

    /**
     * @description logica para enviar formularios pendientes
     */
    const sendFormsPending = async () => {
        try {
            // traigo las answers en pendiente
            // const resFormsPending = await schedulesServices.getFormsAnswersByStatus(FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
            //* trae registros con status pending y que la key checkout sea false
            const resFormsPending = await schedulesServices.getFormsAnswersByStatus2(
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE,
            )
            console.log('sendFormsPending ==============>>🚚 forms pendientes a enviar', resFormsPending.length)
            // console.log('==============>>🚚 forms pendientes a enviar', resFormsPending)
            await sendForms(resFormsPending)

            const resFormsPendingIncidence = await schedulesServices.getFormsAnswersByStatus2(
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE,
                _INCIDENCE,
            )

            // console.log('==============>>🚚 forms incident pendientes a enviar', resFormsPendingIncidence.length)

            await sendForms(resFormsPendingIncidence)
        } catch (error) {
            console.error('2 sendFormsPending: ', error)
        }
    }

    const sendForms = async (formsPending) => {

        // console.log('formsPending => ', formsPending.length)
        if (formsPending == null || formsPending == undefined || formsPending.length == 0) {
            console.log('no hay forms pendientes a enviar..')
            return
        }

        const { isConnected, isInternetReachable } = await NetInfo.fetch()
        console.log('conexion antes de enviar => ', { isConnected, isInternetReachable })

        if (!isConnected || !isInternetReachable) {
            console.log('No hay conexion suficiente para enviar formularios pendientes => ', formsPending.length)
            return
        }

        if (formsPending && formsPending.length > 0) {
            // tengo forms pendientes entonces

            for (const formPending of formsPending) {
                try {
                    const form_id = formPending.form_id
                    const store_id = formPending.store_id
                    const schedule_id = formPending.schedule_id
                    const register_id = formPending._id
                    const name_form = formPending.name_form

                    let answers = JSON.parse(formPending.answers)
                    let status_send = 0
                    // console.log('formPending._id', formPending._id)
                    // console.log('formPending.status', formPending.status)
                    // console.log('formPending.status_send', formPending.status_send)
                    // console.log('formPending.name_form', formPending.name_form)

                    const isPending = formPending.status_send === FORM_SCHEDULE_STATUS.PENDING_CONNECTION

                    if (isPending) {
                        const responseSendForm = await sendForm(
                            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                            null,
                            schedule_id,
                            form_id,
                            store_id,
                            () => {},
                            register_id,
                        ) //este es el posible error

                        console.log('127 --------------- 🚀 ~ responseSendForm:', responseSendForm)

                        status_send = typeof responseSendForm === 'object' && 'send_status' in responseSendForm
                                        ? responseSendForm.send_status
                                        : (responseSendForm as number)

                        console.log("138 -- 🚀 ~ sendFormsPending ~ status_send:", status_send)

                        if (status_send === 1) {
                            console.log('sendForm==============>>🚚 envio el form', form_id, register_id, name_form)

                            // Actualizar status_send
                            await schedulesServices.updateStatusSendForm(
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                schedule_id,
                                form_id,
                                store_id,
                                'COMPLETED desde sendFormsPending',
                                register_id,
                            )
                            
                        } else {
                            console.log('==============>>🚚 error al enviar form', form_id)

                            await schedulesServices.updateStatusFormAnswerSchedule(
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                schedule_id,
                                form_id,
                                store_id,
                                'error al enviar form PENDING_CONNECTION',
                                register_id,
                                checkin_id,
                            )
                            
                            //agrego la actualizacion de status en la nueva key status_send
                            await schedulesServices.updateStatusSendForm(
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                schedule_id,
                                form_id,
                                store_id,
                                'error al enviar form PENDING_CONNECTION',
                                register_id,
                            )
                        }
                    } 
                } catch (error) {
                    console.error('122 sendFormsPending: ', error)
                }
            }
        }
    }

    const isAllQuestionsMandatoryFalse = (questions: any[], type_form = null): boolean => {
        try {
            if (type_form && type_form.type == FORM_TYPES.FORM_REDIRECT) {
                return true
            } else {
                return questions.every((question) => question.mandatory === false)
            }
        } catch (error) {
            console.error('164 -- isAllQuestionsMandatoryFalse: ', error)
            return false
        }
    }

    const sendForm = async (
        status: number,
        actionButonSend?: () => void,
        schedule_id = defaultScheduleId,
        form_id = defaultFormId,
        store_id = defaultStoreId,
        navigate = navigateGoBack,
        register_id: string | null = null,
    ) => {
        let send_status = 0
        let data_alias: string | null = null

        try {
            const {
                fqa_id,
                answers = [],
                date_init,
                date_finish,
                progress_questions_yes_na,
                heladera,
                create_refrigerator,
                type_form,
                form_id_father,
                scoreObtained,
                repeat,
                questions,
                name_form,
                checkin_id,
                day_unique_id,
                scoresByKey,
                totalByKey
            } = await schedulesServices.getFormsAnswers(schedule_id, form_id, store_id, register_id)

            /* ================= VALIDACIÓN DE DÍA ================= */
            if (!register_id && day_unique_id) {
                const currentDayId = generateDayUniqueId()
                if (day_unique_id !== currentDayId) {
                    await captureAndSaveDataError({
                        log: JSON.stringify({
                            error: 'WRONG_DAY_UNIQUE_ID',
                            expected: currentDayId,
                            found: day_unique_id,
                            form_id,
                            schedule_id,
                            store_id,
                            name_form,
                        }),
                        date: new Date().toISOString(),
                        end: 'sendForm - day_unique_id validation',
                    })
                    return { send_status, data_alias }
                }
            }

            /* ================= VALIDACIÓN DE RESPUESTAS ================= */
            const allQuestionMandatoryFalse = isAllQuestionsMandatoryFalse(questions, type_form)

            if (answers.length === 0 && !allQuestionMandatoryFalse) {
                await captureAndSaveDataError({
                    log: JSON.stringify({
                        error: 'EMPTY_ANSWERS',
                        form_id,
                        schedule_id,
                        store_id,
                    }),
                    date: new Date().toISOString(),
                    end: 'sendForm - empty answers',
                })
                return { send_status, data_alias }
            }

            /* ================= SUBIDA DE IMÁGENES ================= */
            if (type_form?.type !== FORM_TYPES.FORM_MODERACION) {
                await verifyAnswersImage(answers)
            }

            /* ================= ARMADO PAYLOAD ================= */
            const obj_json_raw: any = {
                answers,
                date_finish: isValidDateString(date_finish) ? date_finish : date_init,
                date_init,
                id_activity: form_id,
                status: 0,
                progress: progress_questions_yes_na,
                score: scoreObtained,
                heladera,
                create_refrigerator,
                input_type: type_form?.type ?? null,
                refrigerator_id: '',
                store_id,
                scoresByKey: scoresByKey,
                totalByKey: totalByKey,
            }

            // Evitar enviar id_activity con valor '0' — comprobar explícitamente
            if (form_id_father && form_id_father !== '' && form_id_father != '0') {
                obj_json_raw.id_activity = form_id_father
                obj_json_raw.refrigerator_id = form_id
            } else if (heladera === 1) {
                const { form } = getFormRefrigerator(forms_refrigerators, form_id)
                if (form?.refrigerator_id) {
                    obj_json_raw.refrigerator_id = form.refrigerator_id
                }
            }

            /* ================= CHECKIN ================= */
            let data_checkin_id = currentCheckin

            if (isValidMongoId(checkin_id)) {
                data_checkin_id = checkin_id
            } else if (store_id) {
                const checkin = await schedulesServices.get_checkin(store_id, schedule_id)
                if (checkin && checkin?.length) {
                    data_checkin_id = checkin.at(-1).checkin_id
                }
            }

            /* ================= ENVÍO ================= */
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() ?? ''
            const dif_utc = (-new Date().getTimezoneOffset() / 60).toString()

            const bodySendForm = {
                form: JSON.stringify([obj_json_raw]),
                process_now: true,
                date: new Date().toISOString(),
                schedule_id: schedule_id,
                checkin_id: data_checkin_id,
                dif_utc: dif_utc,
            }

            const res = await request_save_form({
                authToken,
                body: bodySendForm,
            })

            if (!res?.response || res.response.status !== 1) {
                return { send_status, data_alias }
            }

            /* ================= POST ENVÍO ================= */
            send_status = res.status
            data_alias = res?.response?.single?.data_alias ?? null

            // ✅ Actualizar status a COMPLETED solo cuando el backend confirma que recibió el formulario
            if (res.status === 1) {

                console.log('sendForm==============>>🚚 envio exitoso del form, actualizando status a COMPLETED', form_id, register_id, name_form)
                await schedulesServices.updateStatusFormAnswerSchedule(
                    FORM_SCHEDULE_STATUS.COMPLETED,
                    schedule_id,
                    form_id,
                    store_id,
                    'enviado exitosamente al servidor',
                    fqa_id,
                    checkin_id,
                )

                // ✅ Limpiar respuestas después del envío exitoso
                const shouldClearAnswers = false
                    // (repeat === 1 && schedule_id !== 'wise') ||
                    // name_form?.toLowerCase().includes('registro epp') ||
                    // name_form?.toLowerCase().includes('auditor')

                if (shouldClearAnswers) {
                    console.log(`🧹 Limpiando respuestas del formulario "${name_form}" (schedule: ${schedule_id})`)
                    await schedulesServices.clearFqaAnswersById(fqa_id)
                }

                const kpiCreated = res?.response?.single?.kpiCreated
                if (kpiCreated && kpiCreated.length > 0 && store_id) {
                    useStoreKpisStore.getState().setStoreKpis(store_id, kpiCreated)
                }

                if (store_id && form_id) {
                    useFormSendStatusStore.getState().markFormSent(store_id, form_id, FORM_SCHEDULE_STATUS.COMPLETED)
                }
            }

            if (actionButonSend) {
                actionButonSend()
            } else {
                navigate()
            }

            return { send_status, data_alias }
        } catch (err) {
            console.error('sendForm error:', err)

            await captureAndSaveDataError({
                log: JSON.stringify(err instanceof Error ? err.message : err),
                date: new Date().toISOString(),
                end: 'sendForm catch',
            })

            throw err
        }
    }

    /**
     * @description recorre las imagenes y las sube a s3
     * @param answers []
     */
    const verifyAnswersImage = async (answers) => {
        try {
            for (const ans of answers) {
                if (ans && ans.pickerResult_uri && ans.pickerResult_uri !== '') {
                    await uploadImage(ans.media, ans.pickerResult_uri)
                }
                if (ans && Array.isArray(ans.data_medias) && ans.data_medias.length > 0) {
                    console.log('tengo data medias =======')
                    for (const entry of ans.data_medias) {
                        if (entry.filename && entry.pickerResult_uri) {
                            await uploadImage(entry.filename, entry.pickerResult_uri)
                        }
                    }
                }
            }
        } catch (error) {
            console.error('verifyAnswersImage: ', error)
        }
    }

    const openFinishSheet = () => {
        openBottomSheet(<FinishSheet closeBottomSheet={closeBottomSheet} title={title ?? ''} />)
    }

    const navigateGoBack = () => {
        navigation.goBack()
    }

    const updateStatusContext = (contextArray) => {
        const index = contextArray.findIndex((form) => form._id.toString() === form_id.toString())

        if (index !== -1) {
            const updatedForms = [...contextArray]
            updatedForms[index] = {
                ...updatedForms[index],
                status: status, // Cambia el status aquí
            }

            setFormsContext(updatedForms)
            setReloadChange()
        }
    }

    return {
        isOpen,
        sendFormsPending,
        sendForm,
        reloadData,
        isLoadingReload,
        openBottomSheet,
        closeBottomSheet,
        setIsLoadingReload,
        setbuttonActive,
        buttonActive,
    }
}
